import { getModel } from "core-web/state";
import { post } from "core-web/libs/GrebbCommerceAPI/util/authClient";

export default async (basketId, parameters = {}) => {
    const response = await post(`/frontend/basket/${basketId}/update`, {
        application_id: getModel("application").applicationId,
        ...parameters,
    });

    return await response;
};
